@import '~style-sheet-helpers/core.less';

@font-size: 14px;

.drawer-bulk-set-weight {
  display: grid;
  grid-template-columns: auto 1fr auto;
  font-size: @font-size;

  > .weight-input-label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .weight {
    display: flex;
    min-width: 0;

    .weight-input {
      width: 100px;
    }
  }
}
